import { Badge, Text } from "@mantine/core";
import { IconClipboardX } from "@tabler/icons-react";
import React from "react";
import { getSkypointOverdueNotes } from "../../../services/skypointAlerts";
import SkypointAlertsTablePage from "./SkypointAlertsTablePage";

const columns = [
  {
    key: "provider",
    header: "Provider",
    width: 200,
    render: (item) => (
      <Text weight={500} size="sm">
        {item.providerName}
      </Text>
    ),
  },
  {
    key: "client",
    header: "Client Name",
    width: 200,
    render: (item) => (
      <Text size="sm" color={item.clientName ? "dark" : "dimmed"}>
        {item.clientName || "—"}
      </Text>
    ),
  },
  {
    key: "noteType",
    header: "Note Type",
    render: (item) => <Text size="sm">{item.noteType}</Text>,
  },
  {
    key: "author",
    header: "Author",
    width: 180,
    render: (item) => (
      <Text size="sm" color={item.author ? "dark" : "dimmed"}>
        {item.author || "—"}
      </Text>
    ),
  },
  {
    key: "overdue",
    header: "Overdue",
    width: 110,
    render: (item) => (
      <Badge
        color={
          item.daysOverdue >= 14 ? "red" : item.daysOverdue >= 7 ? "orange" : "yellow"
        }
        variant="light"
        size="sm"
      >
        {item.daysOverdue} {item.daysOverdue === 1 ? "day" : "days"}
      </Badge>
    ),
  },
  {
    key: "date",
    header: "Note Date",
    width: 130,
    render: (item) => (
      <Text size="xs" color="dimmed">
        {item.relatedDate ? new Date(item.relatedDate).toLocaleDateString() : "—"}
      </Text>
    ),
  },
];

const OverdueNotes = ({ isSidebarOpen }) => (
  <SkypointAlertsTablePage
    isSidebarOpen={isSidebarOpen}
    title="Overdue Notes"
    description="Notes pending approval whose note date is more than 3 days old"
    Icon={IconClipboardX}
    iconColor="#F04438"
    iconBg="#FEF3F2"
    columns={columns}
    stateSelector={(state) => state?.skypointAlerts?.overdueNotes}
    fetcher={getSkypointOverdueNotes}
    emptyMessage="No overdue notes across your providers."
    itemUnit="note"
  />
);

export default OverdueNotes;
